import { isOtherStoriesBrand } from "@pb/utils/brandConfig";
const portfolioBrandMapping = (article) => {
    var _a, _b, _c;
    // extra product marker mapping for COS case
    const portfolioBrandMarkers = (_a = article.markers) === null || _a === void 0 ? void 0 : _a.map((marker) => {
        const { type, text } = marker;
        let finalType = type;
        if (type === 'product') {
            finalType = 'online-exclusive';
        }
        else if (type === 'promotion') {
            finalType = 'environment';
        }
        if (isOtherStoriesBrand)
            finalType = '';
        return {
            type: finalType,
            text,
        };
    });
    const portfolioBrandSpecificDetails = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (((_b = article.whitePrice) === null || _b === void 0 ? void 0 : _b.price) && { regularPriceValue: article.whitePrice.price })), (((_c = article.redPrice) === null || _c === void 0 ? void 0 : _c.price) && { redPriceValue: article.redPrice.price })), { showFavoriteButton: false, initialFavouriteStatus: false, showRedPriceFirst: false, isMarkersAboveProductName: false, isPriceBelowProductMarkers: isOtherStoriesBrand && true, isNewProductMarkerOnTop: true }), (article.sellingAttribute && article.new && { topLabelText: article.sellingAttribute })), { hasOneMarkerPerLine: true }), ((portfolioBrandMarkers === null || portfolioBrandMarkers === void 0 ? void 0 : portfolioBrandMarkers.length) && { markers: portfolioBrandMarkers })), { regularPriceClassName: 'priceElement', titleClassName: 'productName', redPriceClassName: 'priceElement', bluePriceClassName: 'priceElement', markerWrapperClassname: 'markerElements' });
    return portfolioBrandSpecificDetails;
};
export default portfolioBrandMapping;
//# sourceMappingURL=portfolioBrandMapping.js.map